module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/438.135e2cf4.png";